import React from 'react';
import { Button, Card, Typography, Space, Modal } from 'antd';
import useDateRange from '@/hooks/use-date-range';
import { safemomentmax } from '../UtilityData/New-Summary/utils';
import moment from 'moment';
import { useSummaryData } from '../UtilityData/New-Summary/hooks/useSummaryData';
import { useSelector } from 'react-redux';
import { useRequest } from 'ahooks';
import { api } from '@/redux/api';
import { DashboardOutlined } from '@ant-design/icons';
import UpdateEuiTable from './certify-new/update-eui-table';

const { Title } = Typography;

const SectionCard = ({ title, children, icon: Icon, color }) => (
    <Card 
        bordered={false}
        style={{ 
            borderRadius: '16px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            marginBottom: '24px',
            overflow: 'hidden'
        }}
    >
        <div style={{
            background: `linear-gradient(135deg, ${color}, ${color}dd)`,
            margin: '-24px -24px 24px -24px',
            padding: '20px 24px',
            color: 'white'
        }}>
            <Space align="center">
                <Icon style={{ fontSize: '20px' }} />
                <Title level={4} style={{ margin: 0, color: 'white' }}>
                    {title}
                </Title>
            </Space>
        </div>
        {children}
    </Card>
);

const UpdateEUI = ({ updateEUI, task }) => {

    const dateRange = useDateRange();
    const facilityId = useSelector(state => state.Facility.selected.Id);
    const currentUserId = useSelector(state => state.Auth.userId);

    let endingMonth = moment(safemomentmax(
        moment(dateRange.date_range_elec_max),
        moment(dateRange.date_range_gas_max)
    )).format("YYYY-MM");

    const {data: benchmarkData} = useRequest(() => {
        return api.getBenchmarkByFacilityId(facilityId);
    });

    const {data: currentSelectedFacility ={}} = useRequest(() => {
        return api.getCurrentFacility().then(res => {
            if(res.status === 200) {
                return res.data;
            }
        });
    });

    const {data: facilityCategoryOptions = []} = useRequest(() => {
        return api.getFacilityCategory(true).then(res => {
            if(res.status === 200) {
                return res.data?.results || [];
            }
        });
    });

    // 根据 facility_category ID 获取对应的名称
    const getFacilityCategoryName = (categoryId) => {
        if (!categoryId) return '-';
        const category = facilityCategoryOptions.find(item => item.id === categoryId);
        return category?.name || categoryId;
    };
    const {
        data: electricityData = {
          electricity: [],
        },
      } = useSummaryData("electricity", '12', endingMonth);

      const {
        data: gasData = {
          gas: [],
        },
      } = useSummaryData("gas", '12', endingMonth);

      const newData = {
        "total_eui": Math.round((electricityData?.annual_eui || 0) + (gasData?.annual_eui || 0)),
        "eui_elec": Math.round((electricityData?.annual_eui || 0)),
        "eui_ng": Math.round((gasData?.annual_eui || 0)),
        "total_costs": (electricityData.total_cost + gasData.total_cost),
        "costs_per_sqft": (gasData.total_area_cost + electricityData.total_area_cost),
        facility: currentSelectedFacility?.name,
        region: currentSelectedFacility?.region,
        year: currentSelectedFacility?.year,
        company: currentSelectedFacility?.company_name,
        company_id: currentSelectedFacility?.company,
        facility_id: currentSelectedFacility?.id,
        city: currentSelectedFacility?.city,
        state: currentSelectedFacility?.state,
        country: currentSelectedFacility?.country,
        size: currentSelectedFacility?.area,
        facility_category: currentSelectedFacility?.facility_category,
        climate_zone: currentSelectedFacility?.climate_zone,
      }
      const oldData = {
        "total_eui": benchmarkData?.eui ?? '-', // EUI (kBtu/q-yr)
        "eui_elec": benchmarkData?.eui_elec ?? '-', // EUI - Elec(kBtu/sq-yr)
        "eui_ng": benchmarkData?.eui_ng ?? '-', // EUI - NG (kBtu/sq-yr)
        "total_costs": benchmarkData?.energy_costs ?? '-', // Energy Costs ($)
        "costs_per_sqft": benchmarkData?.energy_costs_sqft ?? '-', // Energy Costs ($/sqft)
        facility: benchmarkData?.facility, // Facility Name
        region: benchmarkData?.region,
        year: benchmarkData?.year,
        company: benchmarkData?.company,
        city: benchmarkData?.city,
        state: benchmarkData?.state,
        country: benchmarkData?.country,
        size: benchmarkData?.size,
        facility_category: benchmarkData?.facility_category_name,
        climate_zone: benchmarkData?.eui_climate_zoneng,
      }
    return (
        <div>
                <UpdateEuiTable 
                    oldData={oldData}
                    newData={newData}
                    getFacilityCategoryName={getFacilityCategoryName}
                />

            {/* Update Button */}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
                {task.certify_by?.user_id === currentUserId && (
                    <Button 
                        type="primary" 
                        size="large" 
                        onClick={() => {
                            Modal.confirm({
                                title: 'Confirm Update',
                                content: 'Update above facility data in the Benchmark database.',
                                okText: 'Update',
                                cancelText: 'Cancel',
                                onOk: () => {
                                    updateEUI(newData);
                                },
                                onCancel: () => {
                                    // 取消时不执行任何操作
                                }
                            });
                        }}
                        style={{
                            height: '48px',
                            padding: '0 32px',
                            borderRadius: '24px',
                            fontSize: '16px',
                            fontWeight: '600',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            border: 'none',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)'
                        }}
                    >
                        Update
                    </Button>
                )}
            </div>
        </div>
    )
}

export default UpdateEUI;

